import React, { Component } from 'react'
import {
  Button,
  Card
} from 'antd'
import { withTranslation } from 'react-i18next'

class PaymentStatistics extends Component {
  handleExport = async () => {
    this.props.onExport()
  }

  render () {
    const { t } = this.props
    return (
      <div className='eventDownloadBox no-print'>
        <Card
          title={t('download.paymant')}
          size="small"
          style={{marginBottom: 10}}
          key='PaymentStatistics'
        >
          <Button
            onClick={this.handleExport}
            icon="export"
            loading={this.props.exporting}
          >
            {t('download.download')}
          </Button>
        </Card>
      </div>
    )
  }
}

export default withTranslation() (PaymentStatistics)
